import React from "react";
import PropTypes from 'prop-types';
import { fade, makeStyles } from "@material-ui/core/styles";
import InputBase from '@material-ui/core/InputBase';
import SearchIcon from '@material-ui/icons/Search';

const useStyles = makeStyles(theme => ({
    search: {
        position: 'relative',
        borderRadius: theme.shape.borderRadius,
        backgroundColor: fade(theme.palette.common.black, 0.15),
        '&:hover': {
            backgroundColor: fade(theme.palette.common.black, 0.25),
        },
        marginLeft: 0,
        width: '100%',
        maxWidth: 230,
        [theme.breakpoints.up('sm')]: {
            marginLeft: theme.spacing(1),
            width: 'auto',
        },
    },
    searchIcon: {
        width: theme.spacing(7),
        height: '100%',
        position: 'absolute',
        pointerEvents: 'none',
        display: 'flex',
        alignItems: 'center',
        justifyContent: 'center',
        color: "black"
    },
    inputRoot: {
        color: 'inherit',
    },
    inputInput: {
        padding: theme.spacing(1, 1, 1, 7),
        transition: theme.transitions.create('width'),
        width: '100%',
        color: 'white',
        overflow: "auto",
        [theme.breakpoints.up('sm')]: {
            width: 165,
            '&:focus': {
                width: 165,
            },
        },
        '&::placeholder': {
            color: 'white'
        }
    },
    inputInputSmall: {
        padding: theme.spacing(1, 1, 1, 7),
        transition: theme.transitions.create('width'),
        width: '100%',
        color: 'white',
        overflow: "auto",
        [theme.breakpoints.up('sm')]: {
            width: 100,
            '&:focus': {
                width: 120,
            },
        },
        '&::placeholder': {
            color: 'white'
        }
    },
}));

export default function SearchBar(props) {
    const classes = useStyles();

    const {onTextChange, hint, searchText, searchIconColor, onKeyUp, size} = props;

    return (
        <div className={classes.search}>
            <div className={classes.searchIcon} style={searchIconColor ? {color: searchIconColor} : {}}>
                <SearchIcon />
            </div>
            <InputBase
                placeholder={hint || "Search…"}
                classes={{
                    root: classes.inputRoot,
                    input: size === "small" ? classes.inputInputSmall : classes.inputInput,
                }}
                autoComplete="new-password"
                inputProps={{ 'aria-label': 'search' }}
                onChange={(e) => onTextChange(e)}
                value={searchText ? searchText : ""}
                onKeyUp={onKeyUp}
            />
        </div>
    );
};

SearchBar.propTypes = {
    hint: PropTypes.string,
    searchText: PropTypes.string,
    searchIconColor: PropTypes.string,
    onTextChange: PropTypes.func.isRequired,
    size: PropTypes.string,
    onKeyUp: PropTypes.func
};